/*
    此文件为数据接口存放命名，为防止接口太多，造成接口混乱
    命名为大写斜杠
    按页面划分
    例如： 'ORDER_API': '/api/order',
    每个接口注释用途，为方面其他开发人员查找，了解。
    export default {

    }
*/
export default {
  /**查询列表 */
  GET_LIST_API: '/maindata/userAccount/listUserAccount',
  /**获取详情*/
  // 'GET_DETAIL_API': '/maindata/userAccount/listUserAccountById',
  /**获取用户下拉*/
  GET_USER_LIST: '/maindata/person/listPerson',
  /**新增账号*/
  ADD_ACCOUNT_API: '/maindata/userAccount/saveUserAccount',
  /**修改账号*/
  UPDATE_ACCOUNT_API: '/maindata/userAccount/updateUserAccount',
  /**获取账号详情*/
  GET_DETAIL_API: '/maindata/userAccount/getUserAccountById',
  /**删除账号*/
  DELETE_ACCOUNT_API: '/maindata/userAccount/deleteUserAccount',
  //
  GET_LIST_ROLE_API: '/maindata/user/listRolesAndChecked',
  //
  ADD_ASSIGN_ROLE_API: '/maindata/user/saveUserRole',
  // 合作伙伴名称筛选
  LIST_PARTNER_SEARCH: '/maindata/partners/listPartner',
  // 合作伙伴详情
  GET_PARTNER: '/maindata/partners/getPartner',
  // 重置密码
  RESET_PASSWORD: '/maindata/userAccount/reSetUserPassword',
  // 合作伙伴联系人信息
  GET_PARTNER_PERSON: '/maindata/partners/getPartnerPersonInfo',
};
